import {Post} from "types/post";

export default (state = [], action: { type: string, payload: Post[] }) => {
    switch (action.type) {
        case 'FETCH_POSTS':
            return action.payload;
        default:
            return state;
    }
}